import * as types from "../actions/actionTypes"
const initialState = {
  loading: false,
  inProcess:{},
  error:{},
  data:{},
  sms: {},
  checkPhoneNumber: {},
  invite: {},
  invitationProcessing: false,
  invitationData: []
};

const Invitation = (state = initialState, action) => {
  let loadings = {...state.inProcess};
  let errors = {...state.error};
  switch (action.type) {
    // case types.INVITATION_ACCEPT_REQUEST:
    //   errors[action.payLoad] = null;
    //   loadings[action.payLoad] = true;
    //   return { ...state, inProcess: loadings, error: errors };
    // case types.INVITATION_ACCEPT_SUCCESS:
    //   errors[action.payLoad] = false;
    //   loadings[action.payLoad] = false;
    //   return { ...state, inProcess: loadings, error: errors};
    // case types.INVITATION_ACCEPT_FAILURE:
    //   errors[action.payLoad] = true;
    //   loadings[action.payLoad] = false;
    //   return { ...state, inProcess: loadings, error: errors };

    // case types.INVITATION_REJECT_REQUEST:
    //   errors[action.payLoad] = null;
    //   loadings[action.payLoad] = true;
    //   return { ...state, inProcess: loadings, error: errors};
    // case types.INVITATION_REJECT_SUCCESS:
    //   errors[action.payLoad] = false;
    //   loadings[action.payLoad] = false;
    //   return { ...state, inProcess: loadings, error: errors};
    // case types.INVITATION_REJECT_FAILURE:
    //   errors[action.payLoad] = true;
    //   loadings[action.payLoad] = false;
    //   return { ...state, inProcess: loadings, error: errors };

    case types.SEND_SMS_REQUEST:
      return { ...state, loading: true, sms: '' };
    case types.SEND_SMS_SUCCESS:
      return { ...state, loading: false, sms: action.payLoad };
    case types.SEND_SMS_FAILURE:
      return { ...state, loading: false, sms: action.payLoad };

    case types.CHECK_PHONE_NUMBER_REQUEST:
      return { ...state, loading: true };
    case types.CHECK_PHONE_NUMBER_SUCCESS:
      return { ...state, loading: false, checkPhoneNumber: action.payLoad };
    case types.CHECK_PHONE_NUMBER_FAILURE:
      return { ...state, loading: false, checkPhoneNumber: action.payLoad };

    case types.INVITE_REQUEST:
      return { ...state, loading: true, invite: '' };
    case types.INVITE_SUCCESS:
      return { ...state, loading: false, invite: action.payLoad };
    case types.INVITE_FAILURE:
      return { ...state, loading: false, invite: action.payLoad };

    case types.INVITE_TO_APP_REQUEST:
      return { ...state, invitationProcessing: true };
    case types.INVITE_TO_APP_SUCCESS:
      return {
        ...state,
        invitationProcessing: false,
        invitationData: { data: action.data, phoneNumber: action.phoneNumber }
      };
    case types.INVITE_TO_APP_FAILURE:
      return { ...state, invitationProcessing: false };

    default:
      return state;
  }
};

export default Invitation;